import React, { useEffect, useState, useCallback } from 'react'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'
import Sidebar from '../Sidebar/Sidebar'
import { useParams } from 'react-router-dom'

const Week = () => {
  const [syllabus, setSyllabus] = useState('')
  let params = useParams()
  const getVideoDetails = useCallback(async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API}/course/${params.id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      }
    )
    const data = await response.json()
    setSyllabus(data.syallabus)
  }, [params.id])

  useEffect(() => {
    getVideoDetails()
    return () => {
      setSyllabus('')
    }
  }, [getVideoDetails])
  return (
    <>
      <Navbar />
      <div className="grid grid-flow-col grid-cols-5">
        <Sidebar courseId={params.id} />
        <div className="flex flex-col col-span-4 pt-24 border-l-2 pl-5 education-bg">
          <p className="text-5xl font-nunito font-extralight px-10">
            Week {syllabus[params.no - 1]?.week}
          </p>
          <div className="w-full py-5 px-16">
            <div>
              <h2 className='text-3xl text-gray-800 py-4'>{syllabus[params.no - 1]?.topic}</h2>
              <p className='text-sm text-gray-700'>{syllabus[params.no - 1]?.content}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Week
